(function () {
  'use strict';

  const FORM_TYPES = [
    ['contact', 'contact'],
    ['blogs', 'new_comment'],
    ['comments', 'new_comment'],
    ['contact', 'customer']
  ];

  const PASSWORD_FIELD_NAME = 'password';
  const FORM_KEY_NAME = 'form_key';

  const EXCLUDED_FIELDS = [
    'recaptcha-v3-token',
    'g-recaptcha-response',
    'h-captcha-response',
    PASSWORD_FIELD_NAME
  ];

  const STORAGE_KEY = '__shopify_v';

  function getSessionStorage() {
    try {
      return window.sessionStorage;
    } catch {
      return null;
    }
  }

  function getFormKeyInput(form) {
    return form.elements[FORM_KEY_NAME];
  }

  // Returns a function that gives all relevant forms on the page
  const getTargetForms = (function () {
    const selector = FORM_TYPES
      .map(([actionPart, formType]) =>
        `form[action*='/${actionPart}']:not([data-nocaptcha='true']) input[name='form_type'][value='${formType}']`
      )
      .join(',');

    return () => {
      if (!selector) return [];
      return [...document.querySelectorAll(selector)].map(input => input.form);
    };
  })();

  function persistForm(form) {
    const existingKeyInput = getFormKeyInput(form);

    if (!getTargetForms().includes(form)) return;
    if (existingKeyInput && existingKeyInput.value) return;

    try {
      const session = getSessionStorage();
      if (!session) return;

      // Clean up any previously stored value
      const existingInput = getFormKeyInput(form);
      if (existingInput) {
        session.removeItem(existingInput.value);
      }

      // Generate new form key
      const newKey = Array.from(Array(32), () => Math.random().toString(36)[2]).join('');

      // Insert or update hidden input for form_key
      if (!getFormKeyInput(form)) {
        const input = Object.assign(document.createElement('input'), {
          type: 'hidden',
          name: FORM_KEY_NAME
        });
        form.append(input);
      }
      form.elements[FORM_KEY_NAME].value = newKey;

      // Build form data object (excluding sensitive fields)
      const formData = new FormData(form);
      const sensitiveFields = [...EXCLUDED_FIELDS];
      const passwordFields = [...form.querySelectorAll(`input[type='${PASSWORD_FIELD_NAME}']`)].map(el => el.name);
      sensitiveFields.push(...passwordFields);

      const dataToStore = {};
      for (const [key, value] of formData.entries()) {
        if (!sensitiveFields.includes(key)) {
          dataToStore[key] = value;
        }
      }

      session.setItem(newKey, JSON.stringify({
        [STORAGE_KEY]: 1,
        action: form.action,
        data: dataToStore
      }));

    } catch (error) {
      console.error('failed to persist form', error);
    }
  }

  function wrapSubmitHandler(form, persistFn) {
    const originalSubmit = typeof form.submit === 'function'
      ? form.submit
      : HTMLFormElement.prototype.submit;

    const throttledSubmit = (() => {
      let inProgress = false;

      return () => {
        if (inProgress) return;

        inProgress = true;

        try {
          persistFn();
          originalSubmit.call(form);
        } catch (error) {
          console.error('form submit failed', error);
        }

        setTimeout(() => {
          inProgress = false;
        }, 250);
      };
    })();

    try {
      form.submit = throttledSubmit;
    } catch {
      // silently fail
    }

    form.addEventListener('submit', event => {
      event.preventDefault();
      throttledSubmit();
    });

    form.dataset.persistBound = 'true';
  }

  // Main init
  (function () {
    function onSubmitEvent(event) {
      const form = event.target instanceof HTMLFormElement
        ? event.target
        : event.target?.form;

      if (form) {
        persistForm(form);
      }
    }

    document.addEventListener('submit', onSubmitEvent);

    document.addEventListener('DOMContentLoaded', () => {
      const forms = getTargetForms();
      for (const form of forms) {
        if (form.dataset.persistBound !== 'true') {
          wrapSubmitHandler(form, () => persistForm(form));
        }
      }

      // Monitor for dynamically added forms
      const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length) {
            for (const node of mutation.addedNodes) {
              if (
                node.nodeType === 1 &&
                node.tagName === 'FORM' &&
                getTargetForms().includes(node)
              ) {
                wrapSubmitHandler(node, () => persistForm(node));
              }
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Remove initial submit listener
      document.removeEventListener('submit', onSubmitEvent);
    });
  })();
})();
